import React from 'react';

const InterviewStatus = (interview) => {
  const getRecommendation = (interview) => {
    console.log(interview);
    const currentInterviews = interview?.current_interview || [];
    const previousInterviews = interview?.previous_interview || [];
    const currentStatus = interview?.status || 0;
    const interviewLevels = interview?.interview_level || []; // Get interview levels

    console.log(currentInterviews);

    // Check if any current interview recommendation is 3 or 4 (Rejected)
    const hasRejectedCurrent = currentInterviews.some(
      (interview) =>
        interview.interview_recommendation === 4 || interview.status === 3
    );
    if (hasRejectedCurrent) {
      return getStatusName(3); // Interview rejected
    }

    const has2ndOpinion = currentInterviews.some(
      (interview) => interview.interview_recommendation === 3
    );
    if (has2ndOpinion) {
      return getStatusName(1); // Interview again restarted
    }

    const hasRescheduleCurrent = currentInterviews.some(
      (interview) => interview.status === -1
    );
    if (hasRescheduleCurrent) {
      return getStatusName(-1); // Re-scheduled Request
    }

    const hasQueryCurrent = currentInterviews.some(
      (interview) => interview.status === 4
    );
    if (hasQueryCurrent) {
      return getStatusName(4); // Query raised by interviewer
    }

    if (interview?.interview_cand_approval === 0) {
      return getStatusName(-2); // Candidate rejected Interview
    }

    if (currentStatus == -1) {
      return getStatusName(currentStatus);
    }

    // Find the last interview level based on the highest 'sno'
    const lastLevel = interviewLevels.length > 0
      ? interviewLevels.reduce((max, obj) =>
        parseInt(obj.sno) > parseInt(max.sno) ? obj : max
      )
      : null;

    // Find current interview level
    const currentLevel = currentInterviews[0]?.level;

    // Check if currentInterviews is empty
    const allCurrentCompleted =
      Array.isArray(currentInterviews) && currentInterviews.length > 0
        ? currentInterviews.every((interview) => interview.status === 5)
        : false;

    if (allCurrentCompleted) {

      if (!lastLevel) {
        return getStatusName(6); // Default to " Ready for Next Level"
      }

      // If the current level is the last level, return "Interview Completed"
      if (currentLevel === lastLevel.id) {
        return getStatusName(5); // Interview completed
      } else {
        return getStatusName(6); // Ready for Next Level
      }
    }
    if (interview?.interview_cand_approval === 1) {
      return getStatusName(7); // Candidate Accepted Interview
    }

    return getStatusName(interview?.current_interview?.[0]?.status || 0);
  };


  const getStatusName = (statusId) => {
    console.log(statusId)
    switch (statusId) {
      case 0:
        return (
          <span className="text-black px-6 py-2 block w-full text-center">
            Yet to accept
          </span>
        );
      case 1:
        return (
          <span className="bg-blue-700 px-6 py-2 text-white block w-full text-center">
            Scheduled for Interview
          </span>
        );
      case 2:
        return (
          <span className="bg-lime-500 px-6 py-2 text-white block w-full text-center">
            {/* Interviewer Accepted */}
            Candidate sch. accptance pending
          </span>
        );
      case 3:
        return (
          <span className="bg-red-600 px-3 py-2 text-white block w-full text-center">
            Interviewer Rejected Sch.
          </span>
        );
      case 4:
        return (
          <span className="bg-purple-600 px-3 py-2 text-white block w-full text-center">
            Query raised by interviewer
          </span>
        );
      case -2:
        return (
          <span className="bg-red-600 px-3 py-2 text-white block w-full text-center">
            Candidate Declined sch.
          </span>
        );
      case 7:
        return (
          <span className="bg-amber-600 px-3 py-2 text-white block w-full text-center">
            Candidate Accepted sch.
          </span>
        );
      case 5:
        return (
          <span className="bg-green-700 px-3 py-2 text-white block w-full text-center">
            Interview Completed
          </span>
        );
      case 6:
        return (
          <span className="bg-yellow-600 px-3 py-2 text-white block w-full text-center">
            Ready for Next Level
          </span>
        );
      case -1:
        return (
          <span className="bg-orange-600 px-3 py-2 text-white block w-full text-center">
            Re-scheduled Request
          </span>
        );
      default:
        return '-';
    }
  };

  return getRecommendation(interview);
};

export default InterviewStatus;
